import React, { FC, ReactElement, useRef, useState, useSyncExternalStore } from 'react';
import { ResponsiveContainer } from 'recharts';
import { getSidebarTransitionSnapshot, subscribeToSidebarTransition } from '../../../stores/sidebar-transition.store';

interface StableResponsiveContainerProps {
  width?: string | number;
  height?: string | number;
  children: ReactElement;
  style?: React.CSSProperties;
}

const StableResponsiveContainer: FC<StableResponsiveContainerProps> = ({
  width = '100%',
  height = '100%',
  children,
  style,
}) => {
  const isSidebarTransitioning = useSyncExternalStore(subscribeToSidebarTransition, getSidebarTransitionSnapshot);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [lockedWidth, setLockedWidth] = useState<number | null>(null);
  const [prevTransitioning, setPrevTransitioning] = useState(isSidebarTransitioning);

  if (isSidebarTransitioning !== prevTransitioning) {
    setPrevTransitioning(isSidebarTransitioning);

    if (isSidebarTransitioning) {
      const measuredWidth = wrapperRef.current?.offsetWidth ?? 0;
      if (measuredWidth > 0) {
        setLockedWidth(measuredWidth);
      }
    } else {
      setLockedWidth(null);
    }
  }

  const containerWidth = lockedWidth ?? width;
  const wrapperHeight = typeof height === 'number' ? height : '100%';

  return (
    <div
      ref={wrapperRef}
      style={{
        width: '100%',
        height: wrapperHeight,
        overflow: lockedWidth ? 'hidden' : undefined,
      }}
    >
      <ResponsiveContainer width={containerWidth} height={height} style={style}>
        {children}
      </ResponsiveContainer>
    </div>
  );
};

export default StableResponsiveContainer;
